module.exports = __webpack_public_path__ + "static/media/category1.72c72949.png";